import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FinishingTouches = lazyWithPreload(
  () => import('./FinishingTouches'),
)
